// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1027":"6bf29097","5574":"1ff01a93","9312":"53cae3be","9944":"9210b4e7"}[chunkId] + ".chunk.css";
};